import * as STD                                         from '@emersya/mpa-std-lib';
import CM                                               from '@emersya/mpa-components-manager-lib';

export interface IFrameSubComponentConfiguration extends IFrameComponentConfiguration {
	URL? : string | null;
	useIframe : boolean;
};

export class FrameSubComponent extends FrameComponent<
	HTMLIFrameElement | HTMLObjectElement,
	FrameSubComponent,
	IFrameSubComponentConfiguration
>
{
	component_DOM : HTMLIFrameElement | HTMLObjectElement;

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IFrameSubComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLIFrameElement | HTMLObjectElement> STD.DOM.factory({
			tag : configuration.useIframe ? 'iframe' : 'object'
		});
	};
};
export namespace NS {
	export const Component = FrameSubComponent;
	export type Component = FrameSubComponent;
	export type Configuration = IFrameSubComponentConfiguration;
}
;
import { FrameComponent, IFrameComponentConfiguration } from '../Frame/Frame';

CM.declare({
	id :   'frame-sub',
	type : FrameSubComponent
});
